<div class="ag-bg-danger-light " style="min-height: 100vh; width: 100%;">
    <div class="p-1">
        <img src="assets/images/logo-horizontal@4x.png" class="img-fluid" alt="" style="height: 60px;">
    </div>
    <div class="container d-flex flex-column justify-content-start h-100">
        <h1 class="text-center text-black">Bon retour parmi nous ! </h1>

        <div class="col-12 col-md-5 mx-auto align-self-center ">
            <div class="card">
                <div class="card-body">
                    <div *ngIf="!mailSent">
                        <form class="" #fpForm="ngForm" (ngSubmit)="sendMail(fpForm.value)">
                            <div class="text-center mb-3">
                                <img src="assets/template2/images/logo.png" class="img-fluid" alt="" style="height: 80px;">
                            </div>
                            <h6>
                                <div class="mb-3 text-center fw-bold">Mot de passe oublié?</div>
                                <span>Renseignez votre email pour définir un nouveau mot de passe .</span>
                                </h6>
                                <div class="form-row">
                                    <div class="col-md-12">
                                    <div class="position-relative form-group">
                                    <label for="exampleEmail" class="">Email</label>
                                    <input name="email" id="exampleEmail" placeholder="Email ici..." type="email" class="form-control" ngModel required>
                                    </div>
                                    </div>
                                    </div>
                                    <div class="mt-4 d-flex align-items-center justify-content-between">
                                    <h6 class="mb-0">
                                    <a routerLink="/login" class="text-primary">Je dispose déjà d'un compte</a>
                                    </h6>
                                    <div class="ms-auto">
                                    <button class="btn btn-primary btn-sm ag-" [disabled]="fpForm.invalid || loading" type="submit">Récupérer <app-loading [isVisible]="loading"></app-loading></button>
                                    </div>
                                    </div>
                        </form>
                    </div>
    
                    <div  *ngIf="mailSent">
                        <div class="text-center">
                            <img src="assets/template2/images/success.png" alt="">
                        </div>
                        <p class="text-primary mb-3">Un mail de récupération de votre mot de passe vous a été transféré ! Veuillez consulter votre boîte mail. <br> Merci</p>
                        <h6 class="mb-0">
                            <a routerLink="/login" class="text-primary pointer">Retour à la page de connexion</a>
                       </h6>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>


